






















































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import AddButton from '@/components/Admin/Layout/AddButton.vue';
import AddDocumentButton from '@/components/Admin/Layout/AddDocumentButton.vue';
import AddLanguageForm from '@/components/Admin/Forms/AddLanguageForm.vue';
import AddLanguageKeyForm from '@/components/Admin/Forms/AddLanguageKeyForm.vue';
import ImportLanguageCsvForm from '@/components/Admin/Forms/ImportLanguageCsvForm.vue';
import NotifyMethods from '@/mixins/NotifyMethods.vue';

@Component({
    components: {
        AddButton,
        AddDocumentButton,
        AddLanguageForm,
        AddLanguageKeyForm,
        ImportLanguageCsvForm,
    },
    computed: {
        ...mapGetters({
            allLanguages: 'Localization/getAllLanguages',
            languageAllTexts: 'Localization/getLanguageAllTexts',
            addLanguageVisible: 'Localization/getAddLanguageVisible',
            addLanguageKeyVisible: 'Localization/getAddLanguageKeyVisible',
            getImportLanguageCsvVisible: 'Localization/getImportLanguageCsvVisible',
        }),
    },
})
export default class Localization extends Mixins(NotifyMethods) {
    constructor() {
        super();
    }

    public setLanguage(ev: any) {
        const searchOption = this.$store.getters['Localization/getSearchOption'];
        this.$store.commit(Mutations.SET_LANGUAGE_OPTION, ev.srcElement.value);
        this.$store.dispatch(Actions.FETCH_LANGUAGE_ALL_TEXTS, { key: ev.srcElement.value, search: searchOption });
    }

    public serachText(ev: any) {
        const languagehOption = this.$store.getters['Localization/getLanguageOption'];
        this.$store.commit(Mutations.SET_LOCALIZATION_SEARCH_OPTION, ev.srcElement.value);
        this.$store.dispatch(Actions.FETCH_LANGUAGE_ALL_TEXTS, { key: languagehOption, search: ev.srcElement.value });
    }

    public saveText(id: number) {
        const contentElement: any = (this.$refs[`content_${id}`] as HTMLInputElement);
        const keyElement: any = (this.$refs[`key_${id}`] as HTMLInputElement);
        const content = contentElement[0].value;
        const textKey = keyElement[0].innerText;

        if (content === '') {
            return this.notify('content_field_is_required', 'warning');
        }

        const languageKey = this.$store.getters['Localization/getLanguageOption'];
        this.$store.dispatch(Actions.SAVE_LANGUAGE_TEXT, { id, textKey, content, languageKey });
    }

    public addLanguageKey() {
        this.$store.commit(Mutations.SET_ADD_LANGUAGE_KEY_VISIBILITY, true);
    }

    public addLanguage() {
        this.$store.commit(Mutations.SET_ADD_LANGUAGE_VISIBILITY, true);
    }


    public importLanguageCsv() {
        this.$store.commit(Mutations.SET_IMPORT_LANGUAGE_CSV_VISIBILITY, true);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_ALL_LANGUAGES);
        this.$store.dispatch(Actions.FETCH_LANGUAGE_ALL_TEXTS, { key: 'en', search: '' });
    }
}
